import React from 'react'
import HeaderCell, { onHeaderMove } from './HeaderCell'
import { IColumn, PinnedStatus, onFilterChangeWrapped } from './Types'
import { headerResizeHandler } from './CellResizer'
import { getScrollbarSize } from './ScrollUtil'
import { BodySizes } from './BodySizes'

export interface IHeaderProps {
  headers: IColumn[]
  onHeaderMove?: onHeaderMove
  onHeaderResize: headerResizeHandler
  onHeaderResizeCommit: headerResizeHandler
  onFilterChange?: onFilterChangeWrapped

  headerRef?: React.Ref<HTMLDivElement>
  filter: PinnedStatus
  fillerWidth: number
  onScroll?: (event: React.UIEvent<HTMLDivElement>) => void
}

export const Header = React.forwardRef((props: IHeaderProps, ref: React.Ref<HTMLTableElement>) => {
  return (
    <div
      className='cbgms-grid-header'
      ref={props.headerRef}
      style={{ marginBottom: `-${props.filter === PinnedStatus.Center ? getScrollbarSize() : 0}px`, paddingBottom: '0px' }}
      onScroll={props.onScroll}
    >
      <table className='cbgms-grid-fixed' style={{ width: props.headers.reduce((total, header) => total + header.width, 0) }} ref={ref}>
        <BodySizes filter={props.filter} headers={props.headers} fillerWidth={props.fillerWidth} />

        <thead className='cbgms-grid-thead'>
          <tr style={{ height: '75px' }}>
            {props.headers.map(header => (
              <HeaderCell
                key={header.key}
                header={header}
                filter={props.filter}
                onHeaderResize={props.onHeaderResize}
                onHeaderResizeCommit={props.onHeaderResizeCommit}
                onHeaderMove={props.onHeaderMove}
                onFilterChange={props.onFilterChange}
              />
            ))}
          </tr>
        </thead>
      </table>
    </div>
  )
})

export default React.memo(Header)
